import type { ReactNode } from 'react';
import { levelSpec, type Level } from '../lib/levels';

export interface PageHeaderProps {
  /** Уровень экрана: он же задаёт знаменатель всех величин на странице. */
  level?: Level;
  title: string;
  /** Одна строка: назначение или ограничение экрана. */
  purpose?: string;
  actions?: ReactNode;
  children?: ReactNode;
}

export function PageHeader({ level, title, purpose, actions, children }: PageHeaderProps) {
  return (
    <header className="pagehead">
      <div className="pagehead__main">
        {level ? (
          <div className="pagehead__level">{levelSpec(level).caption}</div>
        ) : null}
        <h1 className="pagehead__title">{title}</h1>
        {purpose ? <p className="pagehead__purpose">{purpose}</p> : null}
        {children}
      </div>
      {actions ? <div className="pagehead__actions">{actions}</div> : null}
    </header>
  );
}
